var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.5 169C131.168 169 169 131.168 169 84.5C169 37.8319 131.168 0 84.5 0C37.8319 0 0 37.8319 0 84.5C0 131.168 37.8319 169 84.5 169Z",
    fill: "#D4D6ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.5 158C125.093 158 158 125.093 158 84.5C158 43.9071 125.093 11 84.5 11C43.9071 11 11 43.9071 11 84.5C11 125.093 43.9071 158 84.5 158Z",
    fill: "#D4D6ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7027 149.405C120.437 149.405 149.405 120.437 149.405 84.7027C149.405 48.9684 120.437 20 84.7027 20C48.9684 20 20 48.9684 20 84.7027C20 120.437 48.9684 149.405 84.7027 149.405Z",
    fill: "#D4D6ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 149.325C120.122 149.325 149 120.374 149 84.6624C149 48.9504 120.122 20 84.5 20C48.8776 20 20 48.9504 20 84.6624C20 120.374 48.8776 149.325 84.5 149.325Z",
    fill: "#D4D6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6755 122.669C51.0498 115.876 57.9973 113.984 57.9973 113.984L74.5511 107.793H90.4188L106.973 113.984C106.973 113.984 113.92 115.876 118.294 122.669H46.6755Z",
    fill: "#A5DEF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.142 155H129.788C129.788 150.615 129.53 144.337 129.53 144.337C127.986 118.025 108.945 113.898 108.945 113.898C94.0209 110.287 102.169 133.417 102.169 133.417C101.74 139.006 102.598 146.487 104.142 155Z",
    fill: "#DCDFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3354 92.229H71.6353V113.468H93.3354V92.229Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4212 102.118V92.229H71.6353V97.1303C77.8966 102.29 85.3587 102.977 93.4212 102.118Z",
    fill: "#CBCBB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.578 155C117.007 143.563 116.835 140.382 116.749 136.512C116.492 127.828 114.691 120.433 108.944 113.984L93.4195 108.911C93.4195 108.911 96.6788 114.672 82.4407 114.672C82.4407 114.672 73.0917 114.328 71.7193 108.911L55.9374 113.984C55.9374 113.984 42.4713 117.337 40.1555 131.525L48.0465 146.143L47.7891 155H116.578Z",
    fill: "#B2B7E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.43 60.5857C108.43 55.5125 108.259 50.5252 108.344 45.452C108.43 42.1844 108.688 43.0443 104.999 42.7004C99.8531 42.1844 98.1377 51.815 97.7088 55.9424C97.1942 61.7035 98.4808 67.8086 99.4242 73.4838C99.7673 75.4615 99.6816 79.5889 101.74 80.5348C103.541 81.3086 105.428 79.3309 106.372 77.8692C108.516 74.4297 108.173 69.2704 108.344 65.401C108.43 63.7672 108.43 62.1335 108.43 60.5857Z",
    fill: "url(#paint0_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 89.3053C103.97 97.904 100.111 100.312 100.111 100.312L94.8785 101.343C91.8765 101 86.7302 99.7097 86.7302 99.7097C74.8938 95.6683 71.4629 94.5505 69.576 90.0792C69.576 89.8212 60.3127 57.576 60.3127 57.576C58.7688 40.9804 76.0946 37.5409 78.7535 37.111C81.3266 36.5091 97.8805 31.9518 102.684 47.8594C102.684 47.8594 109.888 66.2607 106.2 89.3053Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5113 42.3563C52.7647 45.1079 52.5931 50.2671 52.8504 56.1143C53.022 60.6716 54.4801 64.541 56.1097 68.9264C58.8544 76.4072 58.8544 76.4072 61.3418 80.7926C61.3418 80.7926 65.2015 86.7257 70.0905 90.8531C68.6324 85.1779 68.2893 80.9646 67.0027 76.6652C65.4588 71.42 65.8877 64.455 68.2035 59.1238C68.2035 59.1238 69.4901 55.5983 74.8937 54.5665C80.2972 53.5346 74.8937 54.5665 74.8937 54.5665L58.5113 42.3563Z",
    fill: "url(#paint1_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.032 75.4614C68.032 75.4614 65.1158 69.0983 60.4841 72.8818C60.4841 72.8818 58.4256 74.5155 60.9987 78.8149C60.9987 78.8149 64.7727 85.006 69.2328 81.5665L68.032 75.4614Z",
    fill: "#ECECD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5168 60.5858C67.5168 60.5858 67.5168 72.0221 69.661 78.1272L67.431 78.5571C67.431 78.5571 66.2302 70.7323 62.1989 70.6463L67.5168 60.5858Z",
    fill: "url(#paint2_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.261 35.9933C129.788 54.9105 73.6934 54.7386 73.6934 54.7386C73.6934 54.7386 67.861 57.4901 58.5119 42.3564C58.5119 42.3564 56.0246 30.4901 82.5279 26.7927C82.5279 26.7927 100.025 24.643 111.261 35.9933Z",
    fill: "url(#paint3_linear_16_129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1994 155H38.2692C38.2692 155 38.355 149.325 38.355 148.895C38.5265 143.306 38.8696 137.631 39.8989 132.127C41.357 124.217 45.1309 117.252 53.6223 115.188C57.482 114.242 60.9128 116.65 62.9713 119.745C62.8856 119.831 66.7453 124.561 62.1994 155Z",
    fill: "#DCDFFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_129",
    x1: 97.6098,
    y1: 61.6661,
    x2: 108.424,
    y2: 61.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_129",
    x1: 78.6281,
    y1: 90.4239,
    x2: 54.2174,
    y2: 32.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_129",
    x1: 75.7848,
    y1: 91.6198,
    x2: 51.374,
    y2: 33.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_129",
    x1: 58.4768,
    y1: 40.7808,
    x2: 115.029,
    y2: 40.7808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4844,
    stopColor: "#D42256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9993,
    stopColor: "#333280"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_129"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 129,
    height: 135,
    rx: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedMale);
export default __webpack_public_path__ + "static/media/selected-male.a3a6c67aa0c704236a6cd1325a165ab1.svg";
export { ForwardRef as ReactComponent };